import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './IdleWarningModal.module.css';
import { Button } from '@resideo/blueprint-oneportal'

interface IdleWarningModalProps {
  isOpen: boolean;
  remainingSeconds: number;
  onContinue: () => void;
  onSignOut: () => void;
}

export const IdleWarningModal: React.FC<IdleWarningModalProps> = ({
  isOpen,
  remainingSeconds,
  onContinue,
  onSignOut,
}) => {
  const [countdown, setCountdown] = useState(remainingSeconds);

  useEffect(() => {
    setCountdown(remainingSeconds);
  }, [remainingSeconds]);

  useEffect(() => {
    if (!isOpen || countdown <= 0) return;

    const timer = setInterval(() => {
      setCountdown((prev) => Math.max(0, prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen, countdown]);

  const { t } = useTranslation();
  const formattedCountdown = `${Math.floor(countdown / 60)}:${String(countdown % 60).padStart(2, '0')}`;

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>{t('idle.title')}</h2>
        <p className={styles.message}>
          {t('idle.message')}
        </p>
        <div className={styles.countdown}>
          <span className={styles.countdownNumber}>{formattedCountdown}</span>
        </div>
        <div className={styles.footer}>
          <Button variant="highlightTertiary" onClick={onSignOut}>
            {t('layout.signOut')}
          </Button>
          <Button
            variant="primary"
            onClick={onContinue}
          >
            {t('idle.continueButton')}
          </Button>
        </div>
      </div>
    </div>
  );
};
